// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__Cjog0","label":"Labeled_label__292Sg","divider":"Labeled_divider__-X4St"};